import React from 'react';
import cn from 'classnames';
import { TabLink as NextNavLink } from '@framework/router/Next/Link';
import FeaturesComponent from '@framework/ui/Pages/Landing/Sections/Features';
import Section from '@framework/ui/Pages/Landing/Sections/Section';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import SectionHeader from '@framework/ui/Pages/Landing/Sections/SectionHeader';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import { featuresTabsList } from '../../Features/tabs';

import baseStyles from '@/dataroom/ui/components/Landing/researchRoom/tenantResearchRoomStyles.module.scss';
import styles from './features.module.scss';

const Features = () => (
  <Section padding="top">
    <SectionContainer>
      <SectionHeader
        title="IPO research distribution just got better."
        description="ResearchRoom provides everything you need for seamless, simplified pre-deal research distribution."
        maxWidth={ 860 }
      />
    </SectionContainer>
    <SectionContainer size="large" narrow>
      <FeaturesComponent
        autoplay
        actionButton={ (
          <NextNavLink
            to="/features"
            dataTest="exploreOurFeatures"
          >
            <Button
              variant={ ButtonVariantType.action }
              className={ cn(baseStyles.actionButton, styles.exploreButton) }
              title="Explore More Features"
              dataTest="exploreOurFeaturesButton"
            />
          </NextNavLink>
        ) }
        tabsList={ featuresTabsList }
      />
    </SectionContainer>
  </Section>
);

export default Features;
